/* eslint-disable */
import React, { useState, useEffect, useCallback, useMemo } from "react";
import { Grid as MatGrid, Button as MatButton, Stack } from "@mui/material";
import { Button, Modal } from "antd";
import { FilterList } from "@mui/icons-material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { customBaseUrl, httpGet, httpPost, httpPut } from "../../store/http";
import { hideLoader, showLoader } from "../../utils/loader";
import AntDropdown from "../../components/CustomDropdown/AntDropdown";
import useMatStyles from "./style";
import Swal from "sweetalert2";
import CreateRuleModal from "./modals/ManageRuleModal";


const TransferInceptor = () => {
  const styles = useMatStyles();

  const [pagination, setPagination] = useState({ current: 0, pageSize: 10 });
  const [metaData, setMetaData] = useState(0);
  const [accounts, setAccounts] = useState([])
  const [narration, setNarration] = useState("");
  const [showReason, setShowReason] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});
  const [showCreateRuleModal, setShowCreateRuleModal] = useState(false);
  const [editingRule, setEditingRule] = useState(null);
  const [interceptionRules, setInterceptionRules] = useState([]);
  const [globalInterceptorSettings, setGlobalInterceptorSettings] = useState({});
  const [showInceptor, setShowInceptor] = useState(false);

  const [search] = useState({
    searchBy: "partTranType",
    searchText: "",
  });

  const handleUpdateInceptor = useCallback(async () => {
    showLoader();
    const res = await httpPut(
      `${customBaseUrl.walletUrl}/api/v1/transfer-interceptor`,
      globalInterceptorSettings
    );
    if (res.status) {
      setGlobalInterceptorSettings(res.data);
      setShowInceptor(false);
      hideLoader();
      Swal.fire("Done", res.message, "success");
    } else {
      hideLoader();
    }
  }, [globalInterceptorSettings]);
  const handleChangePage = async (newPage) => {
    setPagination({ ...pagination, current: newPage });
  };
  const handleChangeRowsPerPage = async (value) => {
    setPagination({ ...pagination, current: 0, pageSize: value });
  };

  const handleApprove = React.useCallback(async (row) => {
    try {
      showLoader();
      const res = await httpPost(`${customBaseUrl.walletUrl}/api/v1/intercepted-transfer/approve/${row.id}`,
        {
          narration: 'approved'
        }
      );
      if (res.status === true) {
        hideLoader();
        Swal.fire('Done', res.messsage, 'success')
      } else {
        hideLoader();
        Swal.fire('Oops!', res.messsage, 'error')
      }
    } catch (err) {
      hideLoader()
    } finally {
      hideLoader();
    }
  }, []);

  const handleReject = React.useCallback(async (row) => {
    try {
      showLoader();
      const res = await httpPost(`${customBaseUrl.walletUrl}/api/v1/intercepted-transfer/disapprove/${row.id}`, { narration });
      if (res.status === true) {
        hideLoader();
        Swal.fire('Done', res.messsage, 'success')
        setNarration("");
        setShowReason(false);
      } else {
        hideLoader();
        setNarration("");
        Swal.fire('Oops!', res.messsage, 'error')
        setShowReason(false);

      }
    } catch (err) {
      hideLoader()
    } finally {
      hideLoader();
    }
  }, [narration]);
  const handleDropdownAction = useCallback((item, row) => {
    setSelectedRow(row);
    if (item === "Approve") handleApprove(row);
    if (item === "Reject") setShowReason(true);
  }, [handleApprove]);
  const columns = useMemo(() => [
    {
      field: "amount",
      headerName: "Amount",
      width: 100,
      editable: false,
      headerClassName: styles.tableHeader,
    },
    {
      field: "benefAccountNumber",
      headerName: "Beneficiary Account Number",
      width: 200,
      editable: false,
      headerClassName: styles.tableHeader,
    },
    {
      field: "beneficiaryName",
      headerName: "Beneficiary Name",
      width: 200,
      editable: false,
      sortable: true,
      description: "Amount Column",
      headerClassName: styles.tableHeader,
    },
    {
      field: "debitAccountNumber",
      headerName: "Debit Account Number",
      width: 200,
      editable: false,
      sortable: true,
      description: "Account Number",
      type: "number",
      headerClassName: styles.tableHeader,
    },
    {
      field: "reason",
      headerName: "Reason",
      width: 300,
      editable: false,
      headerClassName: styles.tableHeader,
      renderCell: ({ row }) => <div>{row?.reason ? row?.reason : 'N/A'}</div>
    },
    {
      field: "senderName",
      headerName: "Sender Name",
      width: 150,
      editable: false,
      headerClassName: styles.tableHeader,
    },
    {
      field: "timestamp",
      headerName: "Created At",
      description: "Time",
      sortable: true,
      width: 100,
      headerClassName: styles.tableHeader,
    },

    {
      field: "approved",
      headerName: "Status",
      width: 100,
      editable: false,
      headerClassName: styles.tableHeader,
      renderCell: ({ row }) => row?.approved ? 'Approved' : 'Not Approved'
    },
    {
      field: "id",
      headerName: " Action",
      width: 100,
      align: "right",
      headerClassName: styles.tableHeader,
      renderCell: ({ row }) => (
        <AntDropdown
          dropDownOptions={["Approve", "Reject"]}
          handleDropdownAction={(item) => handleDropdownAction(item, row)}
          userId={row}
          isArrow
        />
      ),
    },
  ], [styles.tableHeader, handleDropdownAction]);
  const getIncepted = React.useCallback(async (e) => {
    e?.preventDefault();
    showLoader();

    try {
      const url1 = `${customBaseUrl.walletUrl}/api/v1/intercepted-transfer?direction=DESC&page=${pagination.current}&pageSize=${pagination.pageSize}&sortBy=timestamp`;
      const response = await httpGet(url1);
      if (response.status === true) {
        setAccounts(response?.data?.transfers);
        setMetaData(response?.data?.totalElements);
        hideLoader();
      } else {
        hideLoader();
      }
    } catch (err) {
      hideLoader();
    } finally {
      hideLoader();
    }
  }, [pagination.current, pagination.pageSize]);


  const getInterceptionRules = React.useCallback(async () => {
    showLoader();
    const res = await httpGet(
      `${customBaseUrl.tranv2}/api/v1/admin/interception-rules`
    );
    hideLoader();
    if (res?.success) {
      if (Array.isArray(res.data)) {
        setInterceptionRules(res.data);
      } else if (res.data && Array.isArray(res.data.data)) {
        setInterceptionRules(res.data.data);
      } else {
        console.error("Unexpected interception rules response structure:", res);
        setInterceptionRules([]);
      }
    } else {
      console.error("Failed to fetch interception rules:", res?.message || res);
      setInterceptionRules([]);
    }
  }, []);

  const getGlobalInterceptorSettings = React.useCallback(async () => {
    showLoader();
    try {
      const res = await httpGet(`${customBaseUrl.walletUrl}/api/v1/transfer-interceptor`); // Assuming this is the GET endpoint for global settings
      if (res?.status) { // Assuming 'status' for success
        setGlobalInterceptorSettings(res.data);
      } else {
        console.error("Failed to fetch global interceptor settings:", res?.message || res);
      }
    } catch (err) {
      console.error("Error fetching global interceptor settings:", err);
    } finally {
      hideLoader();
    }
  }, []);



  const handleCreateRule = async (values) => {
    showLoader();
    try {
      const res = await httpPost(`${customBaseUrl.tranv2}/api/v1/admin/interception-rules`, values);
      if (res?.success) {
        Swal.fire("Success", "Rule created successfully!", "success");
        setShowCreateRuleModal(false);
        getInterceptionRules(); // Refresh the list of rules
      } else {
        Swal.fire("Error", res?.message || "Failed to create rule.", "error");
      }
    } catch (err) {
      Swal.fire("Error", "An error occurred while creating the rule.", "error");
      console.error(err);
    } finally {
      hideLoader();
    }
  };

  const handleUpdateRule = async (ruleId, values) => {
    showLoader();
    try {
      const res = await httpPut(`${customBaseUrl.tranv2}/api/v1/admin/interception-rules/${ruleId}`, values);
      if (res?.success) {
        Swal.fire("Success", "Rule updated successfully!", "success");
        setShowCreateRuleModal(false);
        setEditingRule(null);
        getInterceptionRules(); // Refresh the list
      } else {
        Swal.fire("Error", res?.message || "Failed to update rule.", "error");
      }
    } catch (err) {
      Swal.fire("Error", "An error occurred while updating the rule.", "error");
      console.error(err);
    } finally {
      hideLoader();
    }
  };

  useEffect(() => {
    // getIncepted();
    getInterceptionRules();
    // getGlobalInterceptorSettings();
  }, [getIncepted, getInterceptionRules, getGlobalInterceptorSettings]);





  return (
    <>
      <Modal
        //   visible={showModal}
        open={showInceptor}
        closable={false}
        footer={null}
        centered
        onCancel={() => {
          setShowInceptor(false);
        }}
        bodyStyle={{
          padding: "23px 73px 44px 73px",
          borderRadius: "12px",
        }}
      >
        <h4 style={{ textAlign: "center", fontWeight: "bold" }}>
          Update Interceptor
        </h4>
        <label className="">Max Amount</label>
        <input
          className="form-control"
          type='number'
          value={globalInterceptorSettings?.maxAmount}
          onChange={(e) => setGlobalInterceptorSettings({ ...globalInterceptorSettings, maxAmount: e.target.value })} // Bind to new state
        />
        {/* leastLivenessScore */}
        <label className="">Max Amount</label>
        <input
          className="form-control"
          type='number'
          min={0}
          max={100}
          value={globalInterceptorSettings?.leastLivenessScore}
          onChange={(e) => setGlobalInterceptorSettings({ ...globalInterceptorSettings, leastLivenessScore: e.target.value })} // Bind to new state
        />
        <label>Facial Interceptor Amount</label>
        <input
          className="form-control"
          type='number'
          value={globalInterceptorSettings?.maxAmountFacial}
          onChange={(e) => setGlobalInterceptorSettings({ ...globalInterceptorSettings, maxAmountFacial: e.target.value })} // Bind to new state
        />
        <label>Combine Interceptor Amount</label>
        <input
          className="form-control"
          type='number'
          value={globalInterceptorSettings?.maxAmountCombined}
          onChange={(e) => setGlobalInterceptorSettings({ ...globalInterceptorSettings, maxAmountCombined: e.target.value })} // Bind to new state
        />
        <label>Start Time</label>
        <input
          className="form-control"
          type='time'
          value={globalInterceptorSettings?.startTime}
          onChange={(e) => setGlobalInterceptorSettings({ ...globalInterceptorSettings, startTime: e.target.value })} // Bind to new state
        />
        <label>Stop Time</label>
        <input
          className="form-control"
          type='time'
          value={globalInterceptorSettings?.stopTime}
          onChange={(e) => setGlobalInterceptorSettings({ ...globalInterceptorSettings, stopTime: e.target.value })} // Bind to new state
        />
        <div style={{ display: "flex", justifyContent: "space-around", marginTop: "20px" }} >
          <button className="btn btn-primary" onClick={() => {
            handleUpdateInceptor();
          }
          }>
            Update
          </button>
          <button className="btn btn-danger" onClick={() => {
            setShowInceptor(false);
          }
          }>
            Cancel
          </button>
        </div>

      </Modal>
      <MatGrid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        className={styles.matGrid}
      >
        <div style={tool}>
          <div className={styles.dibot}>Transfer Interceptor</div>
          <div style={{ display: "flex", gap: "10px" }}>
            <Button type="primary" onClick={() => setShowCreateRuleModal(true)}>
              Create New Rule
            </Button>
          </div>
        </div>
        <table className="table">
          <thead>
            <tr>
              <th>Rule Type</th>
              <th>Description</th>
              <th>Amount Threshold</th>
              <th>Start Time</th>
              <th>End Time</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {interceptionRules.length > 0 ? (
              interceptionRules.map((rule) => (
                <tr key={rule.id}>
                  <td>{rule.ruleTypeDescription}</td>
                  <td>{rule.description || 'N/A'}</td>
                  <td>{rule.formattedAmountThreshold}</td>
                  <td>{rule.startTime || 'N/A'}</td>
                  <td>{rule.endTime || 'N/A'}</td>
                  <td>{rule.status}</td>
                  <td>
                    {/* Action buttons for each rule, e.g., Edit, Delete, Toggle Status */}
                    <Button size="small" onClick={() => { setEditingRule(rule); setShowCreateRuleModal(true); }}>Edit</Button>
                    <Button size="small" danger onClick={() => { }} style={{ marginLeft: 8 }}>Delete</Button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" style={{ textAlign: 'center' }}>No interception rules found.</td>
              </tr>
            )}
          </tbody>
        </table>
      </MatGrid>
      <MatGrid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        className={styles.matGrid}
      >
        <Modal
          open={showReason}
          closable={false}
          footer={null}
          centered
          onCancel={() => {
            setShowReason(false);
          }
          }
          bodyStyle={{
            padding: "23px 73px 44px 73px",
            borderRadius: "12px",
          }}
        >
          <h4 style={{ textAlign: "center", fontWeight: "bold" }}>
            Reason
          </h4>
          <input
            className="form-control"
            type='text'
            value={narration}
            onChange={(e) => setNarration(e.target.value)}
          />
          <div style={{ display: "flex", justifyContent: "space-around", marginTop: "20px" }} >
            <button className="btn btn-primary" onClick={() => {
              handleReject(selectedRow);
            }
            }>
              Reject
            </button>
            <button className="btn btn-danger" onClick={() => {
              setShowReason(false);
            }
            }>
              Cancel
            </button>
          </div>
        </Modal>

        {/* <div style={{ height: 800, width: "100%" }}>
          <DataGrid
            className={styles.table}
            getRowId={(row) => row.id ?? new Date().getTime()}
            rows={search.searchText ? accounts.filter(req => req?.accountNo.toLowerCase()?.includes(search?.searchText.toLowerCase())) : accounts}
            density="comfortable"
            paginationMode="server"
            columns={columns}
            page={pagination.current}
            pageSize={pagination.pageSize}
            onPageSizeChange={(newPageSize) =>
              handleChangeRowsPerPage(newPageSize)
            }
            onPageChange={(newPage) => handleChangePage(newPage)}
            rowsPerPageOptions={[5, 10, 20, 50, 100]}
            components={{ Toolbar: GridToolbar }}

            pagination
            rowCount={metaData}
          />
        </div> */}
      </MatGrid>
      <CreateRuleModal
        showModal={showCreateRuleModal}
        setShowModal={() => {
          setShowCreateRuleModal(false);
          setEditingRule(null);
        }}
        handleSubmitCreate={handleCreateRule}
        handleSubmitUpdate={handleUpdateRule}
        editingRule={editingRule}
      />
    </>
  );
};

const tool = {
  display: "flex",
  borderRadius: "250px",
  justifyContent: "space-between",
  marginBottom: "30px",
};

export default TransferInceptor;